import React from 'react';
import IUrl from '../../../../types/IUrl';
import Form from '../../../../components/molecules/Form/Form';
import IForm from '../../../../types/IForm';
import { PageToPageCreateFormTemplate } from './PageToPageCreateFormTemplate';

type PageToPageCreateFormProps = {
  templatedPreview: IUrl;
  templatedGetAllAllowedRoles?: IUrl;
  form: IForm;
  onSuccess: () => void;
};

export function PageToPageCreateForm({
  templatedPreview,
  templatedGetAllAllowedRoles,
  form,
  onSuccess,
}: PageToPageCreateFormProps) {
  return (
    <Form id="page-to-page-create-form" model={form} onSuccess={onSuccess}>
      <PageToPageCreateFormTemplate
        templatedGetAllAllowedRoles={templatedGetAllAllowedRoles}
        templatedPreview={templatedPreview}
      />
    </Form>
  );
}
